import script from "./ArgonAddressNormalize.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonAddressNormalize.vue?vue&type=script&setup=true&lang=js"

import "./ArgonAddressNormalize.vue?vue&type=style&index=0&id=e7ee4f2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7ee4f2c"]])

export default __exports__